<template>
  <main-layout>
    <b-container class="modal-page d-flex justify-content-center">
      <verification-form :to="$route.params.id" class="modal__card" />
    </b-container>
  </main-layout>
</template>
<script>
/**
 * ==================================================================================
 * Verification page
 * ==================================================================================
 **/

import MainLayout from '@/layouts/MainLayout'
import VerificationForm from '@/components/forms/VerificationForm'

export default {
  metaInfo: function() {
    return {
      title: `Verify ${this.$route.params.id}`
    }
  },
  components: {
    MainLayout,
    VerificationForm
  },
  created() {
    if (
      this.$route.params.id !== 'email' &&
      this.$route.params.id !== 'phone'
    ) {
      this.$router.replace({
        name: 'home'
      })
    }
  }
}
</script>
